
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/specifics/8-pt-grid",
      function () {
        return require("private-next-pages/specifics/8-pt-grid/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/specifics/8-pt-grid"])
      });
    }
  